import React from 'react';
import DialCode from './PaymentDetails/DialCode';
import { instanceOf } from "prop-types";
import { withCookies, Cookies } from 'react-cookie';
import { setCustomerLogin } from './axios';

const validEmailRegex = RegExp(
    /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i
);
// const validateForm = errors => {
   
//     let valid = true;
//     Object.keys(errors).map((key, i) => (

//         errors[key].length > 0 ?  (valid = true) : (valid = false)
//     ));
  
//  console.log(valid);
// };

class SignUp extends React.Component {
    static propTypes = {
        cookies: instanceOf(Cookies).isRequired
    };
    constructor(props) {
        super(props);
        this.state = {
            firstName: null,
            lastName:null,
            email: null,
            password: null,
            number: null,
            MobileCode: null,
            errors: {
                firstName: '',
                lastName:'',
                email: '',
                password: '',
                number: ''
            }
        };
    }

    OnChangeMobileCode = (event) => {
        console.log(event);
        this.setState({MobileCode: event.target.value});
    }

    handleChange = (event) => {
        event.preventDefault();
        const { name, value } = event.target;
        let errors = this.state.errors;

        switch (name) {
            case 'firstName':
                errors.firstName =
                    value.length < 2
                        ? 'First Name must be at least 2 characters long!'
                        : '';
                break;

                case 'lastName':
                    errors.lastName =
                        value.length < 2
                            ? 'Last Name must be at least 2 characters long!'
                            : '';
                    break;
            case 'email':
                errors.email =
                    validEmailRegex.test(value)
                        ? ''
                        : 'Email is not valid!';
                break;
            case 'password':
                errors.password =
                    value.length <= 5
                        ? 'Password must be at least 5 characters long!'
                        : '';
                break;

            case 'number':
                errors.number =
                    value.length > 20
                        ? 'Enter the valid number!'
                        : '';
                break;
            default:
                break;
        }

        this.setState({ errors, [name]: value });
    }

    // handleSubmit = (event) => {
    //     event.preventDefault();
    //     if (validateForm(this.state.errors)) {
    //         console.info('Valid Form')
    //     } else {
    //         console.error('Invalid Form')
    //     }
    // }

    SubmitLogin = (e) => {
        e.preventDefault();
        const {cookies} = this.props;

        let first_name = this.state.firstName;
        let last_name = this.state.lastName;
        let email = this.state.email;
        let profile_image = "";
        let birthday = "";
        let gender = "";
        let login_source = 0;


        let mobile_number = this.state.number;
        let country = this.props.country;
        let country_code = this.props.country_code;
        let currency = this.props.currency;
        let ip_address = this.props.ip_address;
        let password = this.state.password;
        let verified = 1;

        let Verified = '';
        if (verified == 1) {
            Verified = true;
        }

        const dataSearch = {
            first_name: first_name,
            last_name: last_name,
            email: email,
            country_code: country_code,
            verified: Verified,
            uid: ""
        }

        let JsonData = JSON.stringify(dataSearch);

        localStorage.setItem('userDetails', JsonData);
        cookies.set('userDetails', JsonData, { path: '/' });

        setCustomerLogin(first_name, last_name, email, profile_image, birthday, gender, login_source, mobile_number, country, country_code, currency, ip_address, password, verified).then(
            (data) => {
                console.log(data);

                window.location.reload(true);
            },
            (error) => {

            }
        );

    }

    render() {
        const { errors } = this.state;
        return (
            <>

                <input type='text' name='firstName' placeholder="First Name" onChange={this.handleChange} noValidate />
                {errors.firstName.length > 0 &&
                    <span className='error'>{errors.firstName}</span>}


                    <input type='text' name='lastName' placeholder="Last Name" onChange={this.handleChange} noValidate />
                {errors.lastName.length > 0 &&
                    <span className='error'>{errors.lastName}</span>}


                <input type='email' name='email' placeholder="Email" onChange={this.handleChange} noValidate />
                {errors.email.length > 0 &&
                    <span className='error'>{errors.email}</span>}


                <input type='password' name='password' placeholder="Password" onChange={this.handleChange} noValidate />
                {errors.password.length > 0 &&
                    <span className='error'>{errors.password}</span>}




                <div className="guestDtls__col width327">

                    <div className="paymakeFlex textLtr">
                        <div className="guestDtls__contact" style={{margin:'8px 0px 0px 25px'}}>
                            <label for="mCode" className=" frmSelectCont__contact">
                                <select id="mCode" className="frmSelect frmSelectContact" value={this.state.MobileCode} onChange={this.OnChangeMobileCode}>
                                    {DialCode.map((item, key) => (
                                        <option value={item.dial_code}>{item.name}&nbsp;({item.dial_code})</option>
                                    ))}
                                </select>
                            </label><span className="selectedCode">{this.state.MobileCode == null ? this.props.country_code :  this.state.MobileCode}</span></div>
                        <div className="flexOne">

                            <div className="textFieldCol " style={{marginRight:23}}>
                                <input type='number' name='number' placeholder="Mobile Number" onChange={this.handleChange} noValidate  style={{borderLeft:0}}/>
                                {errors.number.length > 0 &&
                                    <span className='error'>{errors.number}</span>}

                            </div>
                        </div>
                    </div>
                </div>

                <button onClick={this.SubmitLogin}>Sign Up</button>
            </>
        );
    }
}


export default withCookies(SignUp);